module.exports = __webpack_public_path__ + "static/parade-2019-c71c55678842dedd76556d6a541f1a95.jpg";